<template>
  <div>
    <!-- {{Modaltype}} -->
          <!-- <pre>{{ QuestionModal }}</pre> -->

          <!-- {{lessonId}}
          {{course_id}}
          {{sectionType}} -->

    <div v-if="Modaltype == 'Question'">
      <div
        class="light-border p-4 my-2"
        v-for="(eachQuestion, index) in QuestionModal"
        :key="index"
      >
        <!-- <pre> {{eachQuestion}}</pre> -->
        <p class="question-container">{{ eachQuestion.questions.title }}</p>
        <p class="font-bold float-right">
          Points: <span>{{ eachQuestion.questions.point }}</span>
        </p>
<!-- <pre>{{eachQuestion.questions.question_input_type_id}}</pre> -->
      <input type="file" v-if="eachQuestion.questions.question_input_type_id === 7"
      @change="showingNotImplemented()"
      />


        <vs-textarea
       
          readonly
          v-if="
            eachQuestion.questions.question_input_type_id === 1 ||
            eachQuestion.questions.question_input_type_id === 2
          "
          label="Write your answer here"
          v-model="eachQuestion.short_answer"
        />

        <LinkPreviewComponent :question_detail="eachQuestion.questions">
        </LinkPreviewComponent>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 3
          "
        >
          <div
            class="options-holder"
            v-for="(options, optionIndex) in eachQuestion.questions
              .questions_options"
            :key="optionIndex"
          >
            <!-- {{eachQuestion.answer}} -->
            <!-- {{options}} -->
            <vs-radio
                          :disabled="true"

              v-model="eachQuestion.answer"
              :name="`custom${index}`"
              :vs-value="options.id"
              >{{ options.option_name }}</vs-radio
            >
          </div>
        </div>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 5
          "
        >

  <!-- <pre>   {{eachQuestion.questions.questions_options}}</pre>    -->
        <v-select :options="eachQuestion.questions.questions_options"
                      v-model="eachQuestion.answer"
              :name="`custom${index}`"
              label="option_name"
              :reduce="option=>option.id"

        ></v-select>

          <!-- <div
            class="options-holder"
            v-for="(options, optionIndex) in eachQuestion.questions
              .questions_options"
            :key="optionIndex"
          >
        
            <vs-radio
              v-model="eachQuestion.answer"
              :name="`custom${index}`"
              :vs-value="options.id"
              >{{ options.option_name }}</vs-radio
            >
          </div> -->
        </div>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 4 ||
            eachQuestion.questions.question_input_type_id === 6
          "
        >
          <div
            class="options-holder"
            v-for="(options, index) in eachQuestion.questions.questions_options"
            :key="index"
          >
            <vs-checkbox
                          :disabled="true"

             v-model="eachQuestion.answer" :vs-value="options.id">{{
              options.option_name
            }}</vs-checkbox>
          </div>
        </div>
        <p><b>Feedback : </b> {{ eachQuestion.questions.feedback }}</p>
        <!-- {{ eachQuestion.questions.links }} -->
      </div>
      <!-- <div class="text-right">
        <vs-button
          class="mx-1"
          color="primary"
          type="filled"
          @click="answerQuestionSubmit()"
          >Save</vs-button
        >
      </div> -->
    </div>

    <!-- For Assignment -->
    <div v-else>
      <div
        class="light-border p-4 my-2"
        v-for="(eachQuestion, index) in QuestionModal"
        :key="index"
      >
        <p class="question-container">{{ eachQuestion.title }}</p>
        <p class="font-bold float-right">
          Points: <span>{{ eachQuestion.point }}</span>
        </p>

        <vs-textarea
          v-if="
            eachQuestion.question_input_type_id === 1 ||
            eachQuestion.question_input_type_id === 2
          "
          label="Write your answer here"
          v-model="eachQuestion.short_answer"

        />

        <LinkPreviewComponent :question_detail="eachQuestion">
        </LinkPreviewComponent>

        <div
          v-if="
            eachQuestion.question_input_type_id === 3 ||
            eachQuestion.question_input_type_id === 5
          "
        >
          <div
            class="options-holder"
            v-for="(options, index) in eachQuestion.questions_options"
            :key="index"
          >
          
              <vs-radio
              :disabled="true"
              v-model="eachQuestion.answer"
              :name="`custom${index}`"
              :vs-value="options.id"
              >{{ options.option_name }}</vs-radio
            >
          </div>
        </div>

        <div
          v-if="
            eachQuestion.question_input_type_id === 4 ||
            eachQuestion.question_input_type_id === 6
          "
        >
          <div
            class="options-holder"
            v-for="(options, index) in eachQuestion.questions_options"
            :key="index"
          >
            <vs-checkbox
                          :disabled="true"

             v-model="eachQuestion.answer" :vs-value="options.id">{{
              options.option_name
            }}</vs-checkbox>
          </div>
        </div>
        <p><b>Feedback : </b> {{ eachQuestion.feedback }}</p>
        <!-- {{ eachQuestion.links }} -->
        
      </div>

       <!-- <div class="text-right">
          <vs-button class="mx-1" color="primary" type="filled"
          @click="answerQuestionSubmit()"
          >Save</vs-button>
        </div> -->
      
     
    </div>

        <!-- For Assignment -->


      <!-- <vs-alert  color="danger" icon="new_releases"
      v-if="QuestionModal.length == 0"
       >
      <span>No Question Has Been Set Now</span>
    </vs-alert> -->
  </div>
</template>

<script>
//courses ->type:1, Lesson->type:2, Topics->3
import LinkPreviewComponent from './LinkPreviewComponent'
// import { SubmitAnswer } from '@/api/course/courseapi'
import vSelect from 'vue-select'

export default {
  name: 'QuestionModal',
  props: {
    QuestionModal: {
      type: Array,
      required: true,
      default: () => {}
    },
    Modaltype: {
      type: String,
      required: true,
      default: 'Question'
    },
    lessonId:{
      type:Number,
      default:null
    },
    course_id:{
      type:Number,
      default:null
    },
    sectionType:{
      type:Number,
      default:null
    }
  },
  components: {
    LinkPreviewComponent,
    vSelect
    
  },
  data () {
    return {
      testingrad: '',
      activeClass:'cursor-not-allowed'
      // answers:[]
    }
  },
  created () {
    if (this.Modaltype == 'Question') {
      this.setQuestionModalAnswer()
    } else {
      this.setQuestionAssignmentAnswer()
    }
  },
  methods: {
    showingNotImplemented () {
      alert('Not Yet Implemented')
    },
    answerQuestionSubmit () {
      
      let payload = []
      if (this.Modaltype == 'Question') {
        payload = this.QuestionModal.map((ele) => {
          return {
            course_id:this.course_id,
            lesson_id: this.lessonId,
            type: this.sectionType,
            course_assignment_or_question_id: ele.id,
            question_bank_question_answer_id:
            ele.Questiontype === 'radio' ? [ele.answer] : ele.answer,
            question_type: 2, // question bank
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype
          }
        }).filter((ele) => {
          if (ele.Questiontype == 'radio' || ele.Questiontype == 'checkbox') {
            return ele.question_bank_question_answer_id.length > 0
          } else {
            return ele.short_answer !== null
          }
        })
      } else {
        payload = this.QuestionModal.map((ele) => {
          return {
            course_id:this.course_id,
            lesson_id: this.lessonId,
            type: this.sectionType,
            assignment_question_id: ele.id,
            assignment_question_answer_id:
            ele.Questiontype === 'radio' ? [ele.answer] : ele.answer,
            question_type: 1, //assignment
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype
          }
        }).filter((ele) => {
          if (ele.Questiontype == 'radio' || ele.Questiontype == 'checkbox') {
            return ele.assignment_question_answer_id.length > 0
          } else {
            return ele.short_answer !== null
          }
        })
      }

      
      if (payload.length) {
        this.saveAnswerQuestion(payload)
      }
    },
    async saveAnswerQuestion (payload) {
      try {
        const answers = {
          answers: payload
        }
        
        const data = await SubmitAnswer(answers)
        
        let successMessage = ''
        if (this.Modaltype == 'Question') {
          successMessage = 'Question Answer Saved successfully'
        } else {
          successMessage = 'Assignmnent Answer Saved Successfully'
          
        }
        this.$vs.notify({
          title: 'Success',
          text: `${successMessage}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        
        this.$vs.notify({
          title: 'error',
          text: 'Something Went Wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    getAnswerId (ele) {
      
      if (ele.Questiontype === 'radio') {
        if (ele.answer == null) {
          return []
        }
      } else {
        return ele.answer
      }
    },
    setQuestionModalAnswer () {
      this.QuestionModal.forEach((ele) => {
        if (
          ele.questions.question_input_type_id == '3' ||
          ele.questions.question_input_type_id == '5'
        ) {
          
          this.$set(
            ele,
            'answer',
            ele.student_answers !== null
              ? ele.student_answers.question_bank_question_answer_id[0]
              : null
          )
          this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'radio'
        } else if (
          ele.questions.question_input_type_id == '4' ||
          ele.questions.question_input_type_id == '6'
        ) {
          // this.$set(ele, 'answer', [])
          this.$set(
            ele,
            'answer',
            ele.student_answers !== null
              ? ele.student_answers.question_bank_question_answer_id
              : []
          )

          this.$set(ele, 'short_answer', null)

          ele.Questiontype = 'checkbox'
        } else {
          this.$set(
            ele,
            'short_answer',
            ele.student_answers !== null
              ? ele.student_answers.short_answer
              : null
          )
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'shortanswer'
        }
      })
    },
    setQuestionAssignmentAnswer () {
      this.QuestionModal.forEach((ele) => {
        
        if (
          ele.question_input_type_id == '3' ||
          ele.question_input_type_id == '5'
        ) {
          
          this.$set(
            ele,
            'answer', ele.student_answers !== null ? ele.student_answers.assignment_question_answer_id[0] : null
          )
          this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'radio'
        } else if (
          ele.question_input_type_id == '4' ||
          ele.question_input_type_id == '6'
        ) {
          // this.$set(ele, 'answer', [])
          this.$set(
            ele, 'answer', ele.student_answers !== null ? ele.student_answers.assignment_question_answer_id : [])

          this.$set(ele, 'short_answer', null)

          ele.Questiontype = 'checkbox'
        } else {
          this.$set(
            ele,
            'short_answer',
            ele.student_answers !== null
              ? ele.student_answers.short_answer
              : null
          )
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'shortanswer'
        }
      })
    }
  }
}
</script>
<style scoped>
.disabled textarea{
  cursor: not-allowed;

}
</style>